<template>
  <section>
    <h3 class="text-left">{{ name }}</h3>
    <slot></slot>
  </section>
</template>

<script>
export default {
  props: {
    name: String
  }
}
</script>
